import { render } from "./BulkPriceHistory.vue?vue&type=template&id=0b6cb74c&scoped=true"
import script from "./BulkPriceHistory.vue?vue&type=script&lang=js"
export * from "./BulkPriceHistory.vue?vue&type=script&lang=js"

import "./BulkPriceHistory.vue?vue&type=style&index=0&id=0b6cb74c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6cb74c"]])

export default __exports__